import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import {
    LoadingWrapper,
    LoadingTextWrapper
} from '../StyledComponents/Classifier/LoadingScreen'
import { QuestionBackLink } from '../StyledComponents/IntroQuestions/Question'
import { FillerDiv } from '../StyledComponents/Fillers'
import { loadTFModel } from '../../actions'
import { PLANT_CLASSIFICATION, CLASSIFIER } from '../../constants/routes'

class ModelDownload extends Component {
    constructor(props) {
        super(props)

        this.backClicked = this.backClicked.bind(this)
    }

    componentDidMount() {
        const {
            history, model, loadModel, image,
        } = this.props

        if (!model) {
            loadModel()
        } else if (!image) {
            history.push(CLASSIFIER)
        } else {
            history.push(PLANT_CLASSIFICATION)
        }
    }

    componentWillReceiveProps(newProps) {
        const { model, history, image } = this.props
        if (!model && newProps.model) {
            if (!image) {
                history.push(CLASSIFIER)
            } else {
                history.push(PLANT_CLASSIFICATION)
            }
        }
    }

    backClicked() {
        this.props.history.goBack()
    }

    render() {
        const backLink = (
            <QuestionBackLink onClick={this.backClicked} >
                <FontAwesome
                    name="close"
                    size="lg"
                />
            </QuestionBackLink>
        )

        return (
            <FillerDiv>
                {backLink}
                <LoadingTextWrapper>
                    {'Das Bilderkennungsmodell wird heruntergeladen, dies kann einige Minuten dauern...'}
                </LoadingTextWrapper>
                <LoadingWrapper><ThreeBounceSpinner /></LoadingWrapper>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    model: state.tensorflowModel.model,
    image: state.classifier.image,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        loadModel: loadTFModel,
    })
)(ModelDownload)



// WEBPACK FOOTER //
// ./src/components/pages/ModelDownload.js